/* target: assets/plv3-variants.js — keeps the PLv3 product page in sync with the variant the customer
   picks in snippets/plv3-variant-picker.liquid (added 2026-09-07). Vanilla JS, no dependencies.
   On every change: resolve the selected option values → the real variant (from the inline JSON that
   Liquid wrote with product.variants | json) → write its id into the form's hidden input[name=id]
   (and fire "change" so Customily and plv3.js see it), repaint price / add-to-cart label / sticky bar
   / bundle-tier prices / availability, and keep ?variant= in the URL (share + refresh keep the choice).
   Also drives the compact quantity stepper next to the add-to-cart button. */
(function () {
  if (window.__plv3Variants) return; window.__plv3Variants = true;
  var X = window.PLX_I18N || {}; function T(k, fb) { return X[k] != null ? X[k] : fb; }
  function rxEsc(s) { return String(s).replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  function hEsc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  var ATC = T('atc', 'Lägg i varukorgen');
  function saveTxt(cents, fmt) { return String(T('save', 'Spara %s')).replace('%s', money(cents, fmt)); }

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  /* Shopify money formatting from shop.money_format (e.g. "{{amount_no_decimals}} kr") */
  function money(cents, fmt) {
    var n = (cents || 0) / 100;
    function fixed(d, thou, dec) {
      var s = n.toFixed(d), parts = s.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.length > 1 ? parts[0] + dec + parts[1] : parts[0];
    }
    var f = fmt || '{{amount_no_decimals}} kr';
    return f.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, key) {
      switch (key) {
        case 'amount': return fixed(2, ',', '.');
        case 'amount_no_decimals': return fixed(0, ',', '.');
        case 'amount_with_comma_separator': return fixed(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fixed(0, '.', ',');
        case 'amount_with_space_separator': return fixed(2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return fixed(0, ' ', ',');
        case 'amount_with_apostrophe_separator': return fixed(2, "'", '.');
        default: return fixed(0, ' ', ',');
      }
    }).replace(/<[^>]*>/g, '');
  }

  function initPicker(vs) {
    var jsonEl = vs.querySelector('script[data-plv3-variant-json]');
    if (!jsonEl) return;
    var variants; try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    if (!variants || !variants.length) return;
    var fmt = vs.getAttribute('data-money') || '';
    var form = document.getElementById(vs.getAttribute('data-form') || '');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var fieldsets = Array.prototype.slice.call(vs.querySelectorAll('fieldset[data-plv3-opt]'));

    function selected() {
      return fieldsets.map(function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; });
    }
    function find(sel) {
      return variants.find(function (v) { return sel.every(function (val, i) { return val === null || v.options[i] === val; }); });
    }
    function setText(selector, text) {
      Array.prototype.forEach.call(document.querySelectorAll(selector), function (el) { el.textContent = text; });
    }
    function paint(sel) {
      fieldsets.forEach(function (fs, i) {
        var valEl = fs.querySelector('[data-plv3-opt-value]');
        if (valEl && sel[i] !== null) valEl.textContent = fs.classList.contains('plv3-opt--bundle') ? sel[i].replace(/\s*\(.*$/, '') : sel[i];
        Array.prototype.forEach.call(fs.querySelectorAll('input[type=radio]'), function (inp) {
          var lbl = fs.querySelector('label[for="' + inp.id + '"]'); if (!lbl) return;
          var want = sel.slice(); want[i] = inp.value;
          var v = find(want);
          lbl.classList.toggle('is-active', inp.checked);
          lbl.classList.toggle('is-unavailable', !v || !v.available);
          var pEl = lbl.querySelector('[data-plv3-tier-price]'), sEl = lbl.querySelector('[data-plv3-tier-save]');
          if (v && pEl) pEl.textContent = money(v.price, fmt);
          if (v && sEl) sEl.textContent = (v.compare_at_price && v.compare_at_price > v.price) ? saveTxt(v.compare_at_price - v.price, fmt) : '';
        });
      });
    }
    /* The theme's OWN submit button. Customily clones it twice (its "Förhandsgranska" preview button
       and its own "Lägg i varukorgen" button, both type=button, attributes copied) — so match on
       type=submit and never rewrite the markup of anything else. */
    function ownAtc() { return form ? form.querySelector('button[type="submit"][data-plv3-atc]') : null; }
    function atcLabel(text) {
      setText('[data-plv3-atc-price]', text);
      /* app-cloned copies carry plain text: rewrite ONLY the text node that reads
         "Lägg i varukorgen · <amount>" (sibling spans such as a savings pill survive) —
         the preview button ("Förhandsgranska") never matches and is left alone */
      var scope = form || document;
      Array.prototype.forEach.call(scope.querySelectorAll('button'), function (b) {
        if (b.querySelector('[data-plv3-atc-price]')) return;
        var w = document.createTreeWalker(b, NodeFilter.SHOW_TEXT), n;
        while ((n = w.nextNode())) {
          var re = new RegExp('(' + rxEsc(ATC) + '\\s*·\\s*)\\S[^]*$'); if (re.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(re, '$1' + text);
        }
      });
    }
    /* "Spara X kr" pill inside the button (PDP-boost variant of the theme, snippets/pdpb-atc-save) */
    function savePill(v) {
      Array.prototype.forEach.call(document.querySelectorAll('[data-pdpb-atc-save]'), function (el) {
        var on = !!(v.compare_at_price && v.compare_at_price > v.price);
        el.hidden = !on;
        if (on) el.textContent = saveTxt(v.compare_at_price - v.price, fmt);
      });
    }
    function sync() {
      var sel = selected();
      var match = find(sel);
      paint(sel);
      var atc = ownAtc();
      if (!match) {
        if (atc) { atc.disabled = true; atc.textContent = T('unavailable', 'Ej tillgänglig'); }
        return;
      }
      if (idInput && String(idInput.value) !== String(match.id)) {
        idInput.value = match.id;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      var now = money(match.price, fmt);
      setText('[data-plv3-price]', now);
      setText('[data-plv3-sticky-price]', now);
      if (atc) {
        if (match.available) {
          atc.disabled = false;
          if (!atc.querySelector('[data-plv3-atc-price]')) atc.innerHTML = hEsc(ATC) + ' · <span data-plv3-atc-price></span>';
          atcLabel(now);
          savePill(match);
        } else { atc.disabled = true; atc.textContent = T('soldOut', 'Slutsåld'); }
      }
      try { var u = new URL(window.location.href); u.searchParams.set('variant', match.id); history.replaceState({}, '', u); } catch (e) {}
      document.dispatchEvent(new CustomEvent('plv3:variant', { detail: { variant: match } }));
    }
    vs.addEventListener('change', function () { setTimeout(sync, 0); });
    sync();
  }

  function initQty(box) {
    var inp = box.querySelector('input[name="quantity"]'); if (!inp) return;
    function clamp() { var n = parseInt(inp.value, 10); if (!(n >= 1)) n = 1; inp.value = n; return n; }
    var minus = box.querySelector('[data-plv3-qty-minus]'), plus = box.querySelector('[data-plv3-qty-plus]');
    if (minus) minus.addEventListener('click', function () { inp.value = Math.max(1, clamp() - 1); inp.dispatchEvent(new Event('change', { bubbles: true })); });
    if (plus) plus.addEventListener('click', function () { inp.value = clamp() + 1; inp.dispatchEvent(new Event('change', { bubbles: true })); });
    inp.addEventListener('change', clamp);
    inp.addEventListener('blur', clamp);
  }

  ready(function () {
    Array.prototype.forEach.call(document.querySelectorAll('[data-plv3-variants]'), initPicker);
    Array.prototype.forEach.call(document.querySelectorAll('[data-plv3-pdp-qty]'), initQty);
  });
})();
